/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICoreContext } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { ICipQuickLinkResources, iconBefore } from './cip-quick-link.props.autogenerated';

export interface ICipQuickLinkViewProps<> {
    iconBefore: iconBefore | undefined;
    ariaLabel: string | undefined;
    target: string | undefined;
    text: string | undefined;
    href: string | undefined;
    className: string;
    context?: ICoreContext;
    resources: ICipQuickLinkResources;
    setModalContent: React.Dispatch<React.SetStateAction<JSX.Element | null>>;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default (props: ICipQuickLinkViewProps) => {
    const { text, href, target, ariaLabel, iconBefore, className } = props;

    return (
        <>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
                href={href}
                target={target ? '_blank' : '_self'}
                aria-label={ariaLabel}
                className={className}
                {...(target ? { rel: 'noreferrer noopener' } : {})}
            >
                <div className={`${className}__wrapper`}>
                    <div className={`${className}__wrapper-frame`}>
                        <span className={`${className}____wrapper-frame-icon ${className}__wrapper-frame-icon-${iconBefore}`}></span>
                    </div>
                    <h4 className={`${className}__label`}>{text}</h4>
                </div>
            </a>
        </>
    );
};
